import {
    CallToActionAnalyticsEvent,
    GTMEventData,
} from "@hermes/utils/analytics";

interface ProductLocatorCallToActionEventData {
    skus: string[];
}

/**
 * This class is used for find-in-store event
 */
export class ProductLocatorCallToActionEvent extends CallToActionAnalyticsEvent {
    public override eventData!: ProductLocatorCallToActionEventData;

    constructor(eventData: ProductLocatorCallToActionEventData) {
        super(eventData);
    }

    /**
     * Overload formatForGTM of inherited class
     * Return formatter for eventaction and eventlabel key
     */
    public override formatForGTM(): GTMEventData {
        return {
            ...super.formatForGTM(),
            eventaction: "Product Locator",
            eventlabel: this.eventData.skus.join(";"),
        };
    }
}
